import http from '@/plugins/axios/axios';

export default class DocumentoService {

    exportarArquivoFiscal(requisicao) {       
        return http.post('/api/documento/arquivo-fiscal/afdt-acjef', requisicao, {responseType: 'blob'});
    } 

    exportarArquivoFiscalAEJ(requisicao) {       
        return http.post('/api/documento/arquivo-fiscal/aej', requisicao, {responseType: 'blob'});
    } 

    uploadAFDV1(requisicao) {       
        return http.post('/api/afd/v1/upload', requisicao);
    }

    uploadAFDV2(requisicao) {       
        return http.post('/api/afd/upload', requisicao);
    }

    processarDadosAFD(requisicao) { 
        return http.post('/api/afd/paginacao?fdb=f', requisicao);
    }

    baixarComprovantes(requisicao) {
        return http.post('/api/relatorio/espelho-ponto/comprovantes-marcacoes/pdf', requisicao, {responseType: 'blob'});
    }
    
}